import { CROSS_MARKET_EMAIL_DYNAMIC_FIELDS } from '@rd-web-markets/shared/dist/util/constants';
import convertHTMLToPlainText from '@rd-web-markets/shared/dist/util/helpers/convertHTMLToPlainText';
const PROJECT_OVERVIEW_HTML_TEXT_CUTOFF = 50;
const projectOverviewHtmlTextPreview = value => {
  const text = convertHTMLToPlainText(value);
  return text.length > PROJECT_OVERVIEW_HTML_TEXT_CUTOFF ? `${text.substring(0, PROJECT_OVERVIEW_HTML_TEXT_CUTOFF)}...` : text;
};
export const USER_PAGE_AVAILABLE_FOR_ACCOUNT_TYPES = ['consultant', 'admin', 'manager'];
export const USER_ACCOUNT_TYPES = ['customer', 'consultant', 'manager', 'admin'];
const adminTab = {
  eventKey: 'admin',
  title: 'admins'
};
const consultantTab = {
  eventKey: 'consultant',
  title: 'consultants'
};
const managerTab = {
  eventKey: 'manager',
  title: 'managers'
};
const customerTab = {
  eventKey: 'customer',
  title: 'customers'
};
export const USER_TABS = {
  admin: [customerTab, consultantTab, managerTab, adminTab],
  consultant: [customerTab, consultantTab, managerTab, adminTab],
  manager: [customerTab, consultantTab, managerTab, adminTab],
  customer: [customerTab, consultantTab, managerTab, adminTab]
};
export const USER_ACCOUNT_TYPES_DISPLAY_NAME = {
  'customer': 'customer',
  'consultant': 'consultant',
  'manager': 'manager',
  'admin': 'admin'
};
export const UTR_TEXT = 'UTR';
export const SPRINT_CLAIM_NAME = 'UK_Sprint_Claim';
export const TEMPLATE_PAGE_TITLE = 'Claim Template Listing';
export const CLAIM_GROUP_ENGAGEMENT_TITLE = 'contacts_email_kick_off_meeting_organization';
export const COMPANY_REQUIRES_COMPANIES_HOUSE_INFO = true;
export const CLAIM_SELECTION_ALLOWS_SLICING_MULTI_YEAR_CLAIMS = false;
export const EDITOR_CLAIM_SPECIFIC_DYNAMIC_FIELDS = [{
  field: 'accounting_period_end_date',
  title: 'Accounting Period End Date',
  editableInModal: true
}, {
  field: 'accounting_period_start_date',
  title: 'Accounting Period Start Date',
  editableInModal: true
}, {
  field: 'total_qualifying_rnd_expenditure',
  title: 'Total Qualifying RND Expenditure'
}];
export const EDITOR_CLAIM_GROUP_DYNAMIC_FIELDS = [{
  field: 'company_overview_rnd_context',
  title: 'Company Overview RND Context'
}, {
  field: 'contacts_to_collaborate_on_rnd',
  title: 'Contacts To Collaborate'
}, {
  field: 'collaborate_pluralize',
  title: 'Collaborate Pluralize'
}];
export const CLAIM_GROUP_DEFAULT_PARAMS = {
  consultants_attributes: [],
  project_methodology: 'project_basis',
  rnd_collaborate_contacts_attributes: [],
  has_overdue_taxes: false,
  has_staff_involved_not_on_payroll: false,
  accounts_provided: false,
  tax_computations_provided: false,
  development_costs_capitalised: false,
  contracted_by_third_party: false,
  received_grants_or_subsidies: false,
  reimburses_staff_expenses: false,
  purchased_company_cars: false,
  has_patents: false,
  staffing_cost_type: 'regular'
};
export const CLAIM_GROUP_EDIT_FORM_FIELDS = {
  showSicCodesString: false,
  showProjectMehotdology: false,
  showOverdueTaxesSection: true,
  showOverdueTaxesQuestion: true,
  showDoesCompanyReimburseStaffExpenses: true,
  showDoesCompanyPayCarAllowance: true,
  showClassificationForRndTaxPurposes: true
};
export const EDITOR_CLAIM_PROJECT_FIELDS = [];
export const NEW_COMPANY_NEEDS_COMPANY_NUMBER = true;
export const CLIENT_CONTACT_TYPES = ['Client Sponsor', 'Technical Contact', 'Financial Contact'];
export const EXTERNAL_CONTACT_TYPES = ['Auditor'];
export const CLAIM_GROUP_EDIT_PAGE_SHOW_YEAR_END_DROPDOWN = false;
export const CLAIM_GROUP_SHOW_ALL_PROJECT = false;
export const APP_FOOTER_TEXT = 'R&D Tax Credits Portal by Ayming';
export const APP_RELEASE_VERSION = 'Release 3.158.1';
export const LOCALE = 'en-GB';
export const ENGINE_NAME = 'UkSection';
export const EMAIL_TEMPLATE_DYNAMIC_FIELDS = {
  email_template: CROSS_MARKET_EMAIL_DYNAMIC_FIELDS,
  client_cost_template: CROSS_MARKET_EMAIL_DYNAMIC_FIELDS,
  claim_schedule_ics_event_template: CROSS_MARKET_EMAIL_DYNAMIC_FIELDS,
  self_declaration_template: CROSS_MARKET_EMAIL_DYNAMIC_FIELDS
};
export const SHOW_CLAIM_GROUP_TASKS = true;
export const SHOW_COMPANY_CLAIM_GROUP_EDIT_FORM_FIELDS = true;
export const MARKET_SPECIFIC_RD_OR_4 = 'R&D';
export const MARKET_SPECIFIC_RD_OR_4_MENU = 'R&D Technical';
export const TEMPLATE_HEADER_TITLE = {
  email_template: 'Configure Kick Off Template',
  client_cost_template: 'Configure Client Cost Template',
  claim_schedule_ics_event_template: 'Configure Ics Event Template',
  self_declaration_template: 'Configure Self - Declaration Email Template',
  kick_off: 'Configure Kick Off Template'
};
export const REPORT_SAVE_PARAM = '';
export const LOCAL_LANGUAGES = ['en'];
export const REPORT_TYPE_INCLUDE_SECTION_COLUMN_NAME = {
  technical: 'include_in_technical_report'
};
export const TASK_TITLE = 'claim_group_tasks';
export const CURRENCY_SYMBOL = '£';
export const DASHBOARD_PAGE_SIDE_BAR_MENU_ITEMS = {
  link: 'dashboards',
  text: 'Dashboards'
};
export const SIDEBAR_MENU_ITEMS_CUSTOMER = [{
  functional: 'claim_group_selector',
  text: '',
  link: ''
}, {
  text: 'dashboard',
  link: 'dashboard'
}, {
  text: 'projects',
  link: 'projects',
  isOpen: false,
  subMenu: [{
    text: 'project_overview',
    link: 'project_overview'
  }, {
    text: 'create_new_project',
    link: 'create_new_project',
    // In the future other parameters can be passed as well
    // It is best to pass the abilities object, and base your conditions on the abilities,
    // so that all user abilities are managed consistently.
    condition: _ref => {
      let {
        userAbilities
      } = _ref;
      return userAbilities.pages.any.canCreateNewProjects;
    }
  }]
}, {
  text: 'claim_costs',
  link: 'claim_costs',
  // icon: 'currency_pound',
  subMenu: true,
  showLastFourChars: true,
  // In the future other parameters can be passed as well
  // It is best to pass the abilities object, and base your conditions on the abilities,
  // so that all user abilities are managed consistently.
  condition: _ref2 => {
    let {
      userAbilities
    } = _ref2;
    return userAbilities.pages.any.canViewClaimGroupCostDataSidebarMenu;
  }
}, {
  text: 'engagement_team',
  link: 'engagement_team'
}, {
  text: 'technical_narratives',
  link: 'technical_narratives'
}, {
  text: 'documents',
  link: 'technical_uploads',
  condition: _ref3 => {
    let {
      userAbilities
    } = _ref3;
    return userAbilities.pages.any.canSeeDocumentsSidebarButton;
  }
}, {
  text: 'data_centre',
  link: 'data_centre',
  condition: _ref4 => {
    let {
      userAbilities
    } = _ref4;
    return userAbilities.pages.any.canViewDataCentreSidebarMenu;
  }
}];
export const SIDEBAR_MENU_ITEMS = [{
  functional: 'claim_group_selector',
  text: '',
  link: ''
}, {
  text: 'claim_overview',
  icon: 'summarize',
  link: 'master'
}, {
  text: 'project_overview',
  icon: 'assignment',
  link: 'project_overview'
}, {
  text: 'claim_costs',
  link: 'claim_costs',
  icon: 'currency_pound',
  subMenu: true,
  showLastFourChars: true
}, {
  text: 'claim_settings',
  icon: 'settings',
  isOpen: false,
  subMenu: [{
    text: 'claim_info',
    link: 'edit/general'
  }, {
    text: 'engagement_team',
    link: 'engagement_team'
  }]
},
// {
//     text: 'emails',
//     icon: 'email',
//     isOpen: true,
//     subMenu: [
//         {
//             text: 'intro_email',
//             link: 'intro_email'
//         },
//         {
//             text: 'claim_schedule',
//             link: 'claim_schedule'
//         },
//         {
//             text: 'schedule_email',
//             link: 'schedule_email'
//         }
//     ]
// },
{
  text: 'documents',
  icon: 'description',
  isOpen: false,
  subMenu: [{
    text: 'r_d_technical',
    link: 'technical_section'
  }, {
    text: 'report_template',
    link: 'report_template'
  }, {
    text: 'data_centre',
    link: 'data_centre'
  }, {
    text: 'documents',
    link: 'technical_uploads'
  }]
}, {
  text: 'review',
  icon: 'rate_review',
  isOpen: false,
  subMenu: [{
    text: 'technical_narratives',
    link: 'technical_narratives'
  }, {
    text: 'manager_technical_review',
    link: 'manager_review'
  }, {
    text: 'client_technical_review',
    link: 'client_review'
  }, {
    text: 'complete_claim',
    link: 'complete_claim'
  }]
}];
export const SIDEBAR_MENU_ITEMS_MANAGER = [{
  functional: 'claim_group_selector',
  text: '',
  link: ''
}, {
  text: 'claim_overview',
  icon: 'summarize',
  link: 'master'
}, {
  text: 'project_overview',
  icon: 'assignment',
  link: 'project_overview'
}, {
  text: 'claim_costs',
  link: 'claim_costs',
  icon: 'currency_pound',
  subMenu: true,
  showLastFourChars: true
}, {
  text: 'claim_settings',
  icon: 'settings',
  isOpen: false,
  subMenu: [{
    text: 'claim_info',
    link: 'edit/general'
  }, {
    text: 'engagement_team',
    link: 'engagement_team'
  }]
},
// {
//     text: 'emails',
//     icon: 'email',
//     isOpen: true,
//     subMenu: [
//         {
//             text: 'intro_email',
//             link: 'intro_email'
//         },
//         {
//             text: 'claim_schedule',
//             link: 'claim_schedule'
//         },
//         {
//             text: 'schedule_email',
//             link: 'schedule_email'
//         }
//     ]
// },
{
  text: 'documents',
  icon: 'description',
  isOpen: false,
  subMenu: [{
    text: 'r_d_technical',
    link: 'technical_section'
  }, {
    text: 'report_template',
    link: 'report_template'
  }, {
    text: 'data_centre',
    link: 'data_centre'
  }, {
    text: 'documents',
    link: 'technical_uploads'
  }]
}, {
  text: 'review',
  icon: 'rate_review',
  isOpen: false,
  subMenu: [{
    text: 'technical_narratives',
    link: 'technical_narratives'
  }, {
    text: 'manager_technical_review',
    link: 'manager_review'
  }, {
    text: 'complete_claim',
    link: 'complete_claim'
  }]
}];
export const SIDEBAR_MENU_ITEMS_CONSULTANT = [{
  functional: 'claim_group_selector',
  text: '',
  link: ''
}, {
  text: 'claim_overview',
  icon: 'summarize',
  link: 'master'
}, {
  text: 'project_overview',
  icon: 'assignment',
  link: 'project_overview'
}, {
  text: 'claim_costs',
  link: 'claim_costs',
  icon: 'currency_pound',
  subMenu: true,
  showLastFourChars: true
}, {
  text: 'claim_settings',
  icon: 'settings',
  isOpen: false,
  subMenu: [{
    text: 'claim_info',
    link: 'edit/general'
  }, {
    text: 'engagement_team',
    link: 'engagement_team'
  }]
},
// {
//     text: 'emails',
//     icon: 'email',
//     isOpen: true,
//     subMenu: [
//         {
//             text: 'intro_email',
//             link: 'intro_email'
//         },
//         {
//             text: 'claim_schedule',
//             link: 'claim_schedule'
//         },
//         {
//             text: 'schedule_email',
//             link: 'schedule_email'
//         }
//     ]
// },
{
  text: 'documents',
  icon: 'description',
  isOpen: false,
  subMenu: [{
    text: 'r_d_technical',
    link: 'technical_section'
  }, {
    text: 'report_template',
    link: 'report_template'
  }, {
    text: 'data_centre',
    link: 'data_centre'
  }, {
    text: 'documents',
    link: 'technical_uploads'
  }]
}, {
  text: 'review',
  icon: 'rate_review',
  isOpen: false,
  subMenu: [{
    text: 'technical_narratives',
    link: 'technical_narratives'
  }, {
    text: 'manager_technical_review',
    link: 'manager_review'
  }, {
    text: 'client_technical_review',
    link: 'client_review'
  }, {
    text: 'complete_claim',
    link: 'complete_claim'
  }]
}];
export const SIDEBAR_NAV_ADMIN_LINKS = [{
  text: 'Claims',
  link: 'claims',
  icon: 'article',
  subMenu: [{
    text: 'My Claims',
    link: 'my_claim_groups'
  }, {
    text: 'All Claims',
    link: 'all_claim_groups'
  }]
}, {
  text: 'Companies',
  link: 'companies',
  icon: 'apartment'
}, {
  text: 'Documents',
  link: 'documents',
  icon: 'description'
}, {
  text: 'Task Management',
  link: 'task_management',
  icon: 'task_alt',
  subMenu: [{
    text: 'List of Companies',
    link: 'list_of_companies'
  }, {
    text: 'My Tasks',
    link: 'time_tracking/my_tasks'
  }]
}, {
  text: 'Users',
  link: 'users',
  icon: 'group'
}, {
  text: 'Sic Code',
  link: 'sic_codes',
  icon: 'privacy_tip'
}, {
  text: 'Allowed Characters',
  link: 'allowed_characters',
  icon: 'token'
}, {
  text: 'Rates',
  link: 'rates',
  icon: 'trending_up'
}, {
  text: 'Templates',
  link: 'templates',
  icon: 'source',
  subMenu: [{
    text: 'Claim Templates',
    link: 'claim_template'
  }, {
    text: 'R&D Report Template',
    link: 'report_templates?template_type=rnd'
  }, {
    text: 'AIF Report Template',
    link: 'report_templates?template_type=aif'
  },
  // {
  //     text: 'Kick Off Email Template',
  //     link: 'kickoff_email_template',
  // },
  // {
  //     text: 'Claim Schedule Ics Event Template',
  //     link: 'claim_schedule_ics_event_template',
  // },
  // {
  //     text: 'Client Cost Template',
  //     link: 'client_cost_template',
  // },
  {
    text: 'Questionnaires',
    link: 'questionnaires'
  }, {
    text: 'faq',
    link: 'faq_template'
  }, {
    text: 'how_to',
    link: 'how_to_template'
  }, {
    text: 'checklist',
    link: 'checklist_template'
  }]
}, {
  text: 'translations',
  link: 'translations',
  icon: 'language'
}];
export const SIDEBAR_NAV_MANAGER_LINKS = [{
  text: 'Claims',
  icon: 'article',
  link: 'my_claims'
}, {
  text: 'Companies',
  link: 'companies',
  icon: 'apartment'
}, {
  text: 'Users',
  link: 'users',
  icon: 'group'
}, {
  text: 'Documents',
  link: 'documents',
  icon: 'description'
}, {
  text: 'Task Management',
  link: 'task_management',
  icon: 'task_alt',
  subMenu: [{
    text: 'List of Companies',
    link: 'list_of_companies'
  }, {
    text: 'My Tasks',
    link: 'time_tracking/my_tasks'
  }]
}, {
  text: 'Sic Code',
  link: 'sic_codes',
  icon: 'privacy_tip'
}, {
  text: 'translations',
  link: 'translations',
  icon: 'language'
}];
export const SIDEBAR_NAV_CLIENT_LINKS = [{
  text: 'All Claims',
  link: ''
}, {
  text: 'Dashboard',
  link: 'dashboards'
}];
export const SIDEBAR_NAV_ACCOUNTANT_LINKS = [{
  text: 'All Claims',
  link: ''
}];
export const SIDEBAR_NAV_CONSULTANT_LINKS = [{
  text: 'Companies',
  icon: 'apartment',
  link: 'companies'
}, {
  text: 'Claims',
  icon: 'article',
  link: 'my_claims'
}, {
  text: 'Task Management',
  icon: 'task_alt',
  link: 'task_management',
  subMenu: [{
    text: 'List of Companies',
    link: 'list_of_companies'
  }, {
    text: 'My Tasks',
    link: 'time_tracking/my_tasks'
  }]
}, {
  text: 'Documents',
  icon: 'description',
  link: 'documents'
}];
export const SIDEBAR_CLAIM_COSTS_LINKS = [{
  text: 'Cost Categories',
  link: 'financial_details/general',
  icon: 'currency_pound'
},
// {
//     text: 'Client Cost Email',
//     link: 'financial_details/email',
//     icon: 'email',
// },
{
  text: 'Edit Claim',
  link: 'edit/general',
  icon: 'settings'
}
// {
//     text: 'Manager Cost Review',
//     link: 'financial_details/manager_review',
//     icon: 'search',
// }
];
export const SIDEBAR_CLAIM_COSTS_LINKS_CUSTOMER = [{
  text: 'Cost Categories',
  link: 'financial_details/general'
}];
export const SIDEBAR_CLAIM_COSTS_LINKS_ACCOUNTANT = [{
  text: 'Cost Categories',
  link: 'financial_details/general'
}];
export const SIDEBAR_TECHNICAL_SECTION_LINKS = [{
  text: 'templates',
  link: 'upload_template',
  subMenu: [{
    text: 'upload_download_project_template',
    link: 'upload_template'
  }, {
    text: 'upload_download_technical_narrative_template',
    link: 'upload_narrative_template'
  }, {
    text: 'upload_download_rnd_report',
    link: 'upload_download_rnd_report'
  }]
}, {
  text: 'documents',
  link: 'technical_uploads'
}];
export const SIDEBAR_CLAIM_OVERVIEW_LINKS_CUSTOMER = [{
  text: 'Claim Cost',
  link: 'claim_cost',
  subMenu: true
}, {
  text: 'R&D Technical',
  link: 'technical_section'
}];
export const SIDEBAR_NAV_RND_REPORT_PAGE_CLIENT_LINKS = {
  link: '',
  text: 'Home'
};
export const CURRENCY_FORMATTER = new Intl.NumberFormat(LOCALE);
export const PERCENTAGE_FORMATTER = new Intl.NumberFormat(LOCALE, {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
});
export const ENGAGEMENT_TEAM_ROLES = [{
  value: 'client_sponsor'
}, {
  value: 'financial_contact'
}, {
  value: 'technical_contact'
}];
export const CLIENT_RND_EDIT_DYNAMIC_FIELD = true;
export const CLIENT_RND_SELECT_PROJECT_POPOVER = true;
export const SUPPORT_EMAIL_ADDRESS = 'uk.support.advance@ayming.com ';
export const ATTACHMENT_OPTIONS = {
  attachCostTemplate: true,
  technicalTemplateField: false,
  includeTechnicalUploadField: false,
  includeCostTemplateLink: false
};
export const TEMPLATE_SELECT_MODEL_NAME = 'REPLACE_IF_NEEDED'; //so the build would not fail other wise not needed yet
export const PROJECT_FIELD_MODEL_NAME = 'REPLACE_IF_NEEDED'; //so the build would not fail other wise not needed yet
export const SHOULD_CREATE_REPORT = false; //so the build would not fail other wise not needed yet

export const modifyReportTemplateCategoriesForProject = [0, 0]; //at index 0, remove no element
export const CONSULTANT_ROLE_NAME = 'consultant';
export const SHOW_DEPARTMENT_FOR_USER_FORM = false;
export const SHOULD_PROJECT_POPOVER_EXCLUDE_OTHER_PROJECTS = false;
export const TINYMCE_MARKET_REPORT_MODULES = ['styles_formatter', 'footnotes', 'track_changes', 'comments', 'resize_image_when_added'];
export const TINYMCE_MARKET_EMAIL_MODULES = [
  // 'styles_formatter',
  // 'resize_image_when_added',
];
export const TINYMCE_MARKET_OTHER_MODULES = ['styles_formatter', 'footnotes', 'track_changes', 'comments', 'resize_image_when_added'];
export const SIDEBAR_NAV_SUPER_CONSULTANT_LINKS = [];
export const SHOW_COST_MENU_IN_MASTER = false;
export const SHOW_DOWNLOAD_TEMPLATE_BUTTON = true;
export const SHOW_SIDE_BAR_IN_CLAIM_GROUP_OVERVIEW = true;
export const FINANCIAL_SECTION_GENERAL_LINK = 'summary';
export const SHOULD_AUTOSAVE = false;
export const SHOULD_PRESET_COMPANY_CLAIMGROUP_FORM_FILEDS = false;
export const SHOULD_SHOW_ADD_USER_BUTTON_FOR_ADMINS = true;
export const SHOULD_SHOW_ADMIN_OPTION_FOR_CONSULTANTS = false;
export const IS_PROJECT_DATE_SHORT_FORMAT = true;
export const DATES_BASED_ON_CURRENT_YEAR = false;
export const SHOULD_SHOW_DATE_IN_SUMMARY_SECTION = true;
export const RATES_SCHEME = {
  'R&D SME Scheme': ['enhanced_deduction', 'payable_credit'],
  'R&D Intensive SME (Loss-making)': ['intensity_threshold', 'payable_credit'],
  'R&D Expenditure Credit (RDEC) Scheme': ['payable_credit'],
  'Corporation Tax Rates': ['rate'],
  'NI Thresholds': ['threshold'],
  'NI Rates': ['rate']
};
export const SHOULD_ADD_REPORT_TEMPLATE_SEARCH = true;
export const SHOULD_SHOW_TEMPLATE_TITLE = true;
export const SHOW_SEND_CLAIM_BUTTON = true;
export const PROJECT_REPORT_DATE_PICKER_TYPE = 'month';
export const SHOW_CLAIM_GROUP_PROJECT_ELSTER = false;
export const SHOW_PROJECT_TEMPLATE_SELECT = false;
export const SHOW_KICK_OFF_DATES = false;
export const SHOW_IT_TYPE_SELECT = false;
export const SHOW_PROJECT_GROUPING_TAB_ON_PROJECT_OVERVIEW_PAGE = true;
export const SHOW_MARKET_PROGRAM_LIST = false;
export const PROJECT_GROUP_RPOGRAM_TYPE_NAME = 'program_commercial_project';
export const PROJECT_OVERVIEW_TABLE = {
  headers: [{
    text: 'subsidiary_company_name',
    sortable: true,
    orderBy: 'subsidiary_company_name',
    filterableByText: true,
    filterBy: 'subsidiary_company_name',
    selectable: _ref5 => {
      let {
        claimGroup
      } = _ref5;
      return claimGroup.company.has_subsidiary_companies;
    },
    selectableErrorTooltipText: 'This column is selected, but it cannot be used because the claim group company has no subsidiary companies.'
  }, {
    text: 'business_unit',
    sortable: true,
    orderBy: 'business_unit',
    filterableByText: true,
    filterBy: 'business_unit'
  }, {
    text: 'name',
    sortable: true,
    orderBy: 'project_name',
    filterableByText: true,
    filterBy: 'project_name',
    required: true,
    cellStyleAttributes: {
      whiteSpace: 'nowrap'
    }
  }, {
    text: 'project_code',
    sortable: true,
    orderBy: 'project_code',
    filterableByText: true,
    filterBy: 'project_code',
    cellStyleAttributes: {
      whiteSpace: 'nowrap'
    }
  }, {
    text: 'theme',
    sortable: true,
    orderBy: 'theme',
    filterableByText: true,
    filterBy: 'project_theme'
  }, {
    text: 'program_type',
    sortable: true,
    orderBy: 'program_type',
    filterableBySelect: true,
    filterBy: 'program_type',
    filterOptions: ['project', 'program_commercial_project', 'connected_to_program_commercial_included_cost', 'connected_to_program_commercial_not_included_cost']
  }, {
    text: 'cost_methodology_type',
    sortable: true,
    orderBy: 'cost_methodology_type',
    filterableBySelect: true,
    filterBy: 'cost_methodology_type',
    filterOptions: ['project_methodology_sampling_sample', 'project_methodology_sampling_extrapolated', 'project_methodology_sampling_excluded', 'project_methodology_sampling_nominated', 'project_methodology_shortlisting_shortlisted', 'project_methodology_shortlisting_not_shortlisted', 'project_methodology_rag_red', 'project_methodology_rag_amber', 'project_methodology_rag_green']
  }, {
    text: 'include_in_technical_report',
    sortable: true,
    orderBy: 'include_in_technical_report',
    filterableBySelect: true,
    filterBy: 'include_in_technical_report',
    filterOptions: ['yes', 'no']
  }, {
    text: 'are_rnd_trials_undertaken',
    sortable: true,
    orderBy: 'are_rnd_trials_undertaken',
    filterableBySelect: true,
    filterBy: 'are_rnd_trials_undertaken',
    filterOptions: ['yes', 'no']
  }, {
    text: 'field_of_science_and_technology',
    sortable: true,
    orderBy: 'field_of_science_and_technology',
    filterableByText: true,
    filterBy: 'field_of_science_and_technology'
  }, {
    text: 'created_by',
    sortable: true,
    orderBy: 'created_by',
    filterableByText: true,
    filterBy: 'created_by',
    cellStyleAttributes: {
      whiteSpace: 'nowrap'
    }
  }, {
    text: 'start_date'
  }, {
    text: 'end_date'
  }, {
    text: 'rnd_start_date'
  }, {
    text: 'rnd_end_date'
  }, {
    width: '180px',
    text: 'assessment',
    sortable: true,
    orderBy: 'assessment',
    filterableBySelect: true,
    filterBy: 'assessment_status',
    filterOptions: ['not_started', 'in_progress', 'completed']
  }, {
    width: '180px',
    text: 'project_category',
    sortable: true,
    orderBy: 'category',
    filterableBySelect: true,
    filterBy: 'project_category',
    filterOptions: ['rnd', 'non_rnd', 'tbc']
  }, {
    width: '180px',
    text: 'project_status',
    sortable: true,
    orderBy: 'completion_status',
    filterableBySelect: true,
    filterBy: 'project_status',
    filterOptions: ['unstarted', 'shortlisted_sampled', 'scoping_scheduled', 'scoping_completed', 'begun_tech_interview_scheduled', 'begun_tech_interview_completed', 'begun_in_manager_qa', 'begun_manager_qa_completed', 'finished']
  }, {
    text: 'escalation_required',
    sortable: true,
    orderBy: 'escalation_required',
    filterableBySelect: true,
    filterBy: 'escalation_required',
    filterOptions: ['yes', 'no']
  }, {
    text: 'commercial_project_name',
    sortable: true,
    orderBy: 'commercial_project_name',
    filterableByText: true,
    filterBy: 'commercial_project_name',
    cellStyleAttributes: {
      whiteSpace: 'nowrap'
    }
  }, {
    text: 'commercial_project_code',
    sortable: true,
    orderBy: 'commercial_project_code',
    filterableByText: true,
    filterBy: 'commercial_project_code'
  }, {
    text: 'commercial_project_cost_methodology_type',
    sortable: true,
    orderBy: 'commercial_project_cost_methodology_type',
    filterableBySelect: true,
    filterBy: 'commercial_project_cost_methodology_type',
    filterOptions: ['project_methodology_sampling_sample', 'project_methodology_sampling_extrapolated', 'project_methodology_sampling_excluded', 'project_methodology_sampling_nominated', 'project_methodology_shortlisting_shortlisted', 'project_methodology_shortlisting_not_shortlisted', 'project_methodology_rag_red', 'project_methodology_rag_amber', 'project_methodology_rag_green']
  }, {
    text: 'cp_name',
    sortable: true,
    orderBy: 'cp_name',
    filterableByText: true,
    filterBy: 'cp_name'
  }, {
    text: 'cp_qualifications',
    sortable: true,
    orderBy: 'cp_qualifications'
  }, {
    text: 'cp_relevant_experience',
    sortable: true,
    orderBy: 'cp_relevant_experience'
  }, {
    text: 'cp_email',
    sortable: true,
    orderBy: 'cp_email',
    filterableByText: true,
    filterBy: 'cp_email'
  }, {
    text: 'cp_phone',
    sortable: true,
    orderBy: 'cp_phone',
    filterableByText: true,
    filterBy: 'cp_phone'
  }, {
    text: 'cp_exclude_from_rnd_report',
    sortable: true,
    orderBy: 'cp_exclude_from_rnd_report',
    filterableBySelect: true,
    filterBy: 'cp_exclude_from_rnd_report',
    filterOptions: ['yes', 'no']
  }, {
    text: 'cp_notes'
  }, {
    width: '140px',
    text: 'total_cost',
    sortable: true,
    orderBy: 'total_cost'
  }, {
    width: '140px',
    text: 'total_qe',
    sortable: true,
    orderBy: 'total_qe'
  }, {
    text: 'rnd_percentage'
  }, {
    text: 'total_rnd_hours'
  }, {
    text: 'customer_name',
    sortable: true,
    orderBy: 'customer_name',
    filterableByText: true,
    filterBy: 'customer_name'
  }, {
    text: 'customer_contract_details'
  }, {
    text: 'customer_contract_upstream_contract'
  }, {
    text: 'customer_contract_upstream_review'
  }, {
    text: 'documents'
  }, {
    text: 'questionnaires'
  }, {
    tooltipWidth: '700px',
    text: 'rd_baseline',
    formatFn: projectOverviewHtmlTextPreview,
    tooltipFn: convertHTMLToPlainText
  }, {
    tooltipWidth: '700px',
    text: 'rd_advance',
    formatFn: projectOverviewHtmlTextPreview,
    tooltipFn: convertHTMLToPlainText
  }, {
    tooltipWidth: '700px',
    text: 'rd_uncertainty',
    formatFn: projectOverviewHtmlTextPreview,
    tooltipFn: convertHTMLToPlainText
  }, {
    tooltipWidth: '700px',
    text: 'rd_work_done',
    formatFn: projectOverviewHtmlTextPreview,
    tooltipFn: convertHTMLToPlainText
  }, {
    tooltipWidth: '700px',
    text: 'rd_additional_comments',
    formatFn: projectOverviewHtmlTextPreview,
    tooltipFn: convertHTMLToPlainText
  }, {
    tooltipWidth: '700px',
    text: 'tn_knowledge',
    formatFn: projectOverviewHtmlTextPreview,
    tooltipFn: convertHTMLToPlainText
  }, {
    tooltipWidth: '700px',
    text: 'tn_advances',
    formatFn: projectOverviewHtmlTextPreview,
    tooltipFn: convertHTMLToPlainText
  }, {
    tooltipWidth: '700px',
    text: 'tn_uncertainties',
    formatFn: projectOverviewHtmlTextPreview,
    tooltipFn: convertHTMLToPlainText
  }, {
    tooltipWidth: '700px',
    text: 'tn_overcome',
    formatFn: projectOverviewHtmlTextPreview,
    tooltipFn: convertHTMLToPlainText
  }],
  columns: ['subsidiary_company_name', 'business_unit', 'project_name', 'project_code', 'theme', 'program_type', 'cost_methodology_type', 'include_in_technical_report', 'are_rnd_trials_undertaken', 'field_of_science_and_technology', 'created_by', 'start_date', 'end_date', 'rnd_start_date', 'rnd_end_date', 'assessment', 'category', 'completion_status', 'escalation_required', 'commercial_project_name', 'commercial_project_code', 'commercial_project_cost_methodology_type', 'cp_name', 'cp_qualifications', 'cp_relevant_experience', 'cp_email', 'cp_phone', 'cp_exclude_from_rnd_report', 'cp_notes', 'total_cost', 'total_qe', 'rnd_percentage', 'total_rnd_hours', 'customer_name', 'customer_contract_details', 'customer_contract_upstream_contract', 'customer_contract_upstream_review', 'documents', 'questionnaires', 'rd_baseline', 'rd_advance', 'rd_uncertainty', 'rd_work_done', 'rd_additional_comments', 'tn_knowledge', 'tn_advances', 'tn_uncertainties', 'tn_overcome', 'deleteButton']
};
export const PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR = true;
export const PROJECT_OVERVIEW_TABLE_EMPTY_COLUMN_SELECTOR_JSON = {
  sections: {
    'Project Details': {
      'subsidiary_company_name': true,
      'project_name': true,
      'project_code': true,
      'business_unit': true,
      'theme': true,
      'program_type': false,
      'cost_methodology_type': false,
      'include_in_technical_report': false,
      'are_rnd_trials_undertaken': false,
      'field_of_science_and_technology': false,
      'created_by': false
    },
    'Dates': {
      'start_date': false,
      'end_date': false,
      'rnd_start_date': false,
      'rnd_end_date': false
    },
    'Rnd Assessment': {
      'assessment': true,
      'category': true,
      'completion_status': true,
      'escalation_required': true,
      'rd_baseline': false,
      'rd_advance': false,
      'rd_uncertainty': false,
      'rd_work_done': false,
      'rd_additional_comments': false
    },
    'Commercial Project': {
      'commercial_project_name': false,
      'commercial_project_code': false,
      'commercial_project_cost_methodology_type': false
    },
    'Technical Narrative': {
      'tn_knowledge': false,
      'tn_advances': false,
      'tn_uncertainties': false,
      'tn_overcome': false
    },
    'Competent Professional': {
      'cp_name': false,
      'cp_qualifications': false,
      'cp_relevant_experience': false,
      'cp_email': false,
      'cp_phone': false,
      'cp_exclude_from_rnd_report': false,
      'cp_notes': false
    },
    'Costs & financials': {
      'total_cost': true,
      'total_qe': true,
      'rnd_percentage': false,
      'total_rnd_hours': false
    },
    'Customer': {
      'customer_name': false,
      'customer_contract_details': false,
      'customer_contract_upstream_contract': false,
      'customer_contract_upstream_review': false
    },
    'Additional': {
      'documents': true,
      'questionnaires': true
    }
  },
  selectedColumns: ['subsidiary_company_name', 'business_unit', 'project_name', 'project_code', 'theme', 'category', 'total_cost', 'total_qe', 'assessment', 'completion_status', 'documents', 'questionnaires', 'escalation_required']
};
export const PROJECT_OVERVIEW_TABLE_MINIMUM_REQUIRED_COLUMNS = ['project_name'];
export const PROJECT_EXPORT_FIELDS_LIST = ['entity', 'commercial_project_name', 'cost_methodology_type', 'business_unit', 'theme', 'project_name', 'project_code', 'project_start_date', 'project_end_date', 'project_rnd_start_date', 'project_rnd_end_date', 'project_type', 'r&d_status', 'assessment', 'completion_status', 'commercial_project_code', 'commercial_project_type', 'include_in_rnd_report', 'rnd_project_baseline', 'rnd_project_advance', 'rnd_project_uncertainty', 'rnd_project_work_done', 'rnd_project_additional_comments', 'technical_narrative_project_background', 'technical_narrative_current_state_of_knowledge', 'scientific_or_technological_advances_sought', 'technical_narrative_technical_uncertainties', 'technical_narrative_uncertainties_overcome', 'created_by', 'competent_professional_name', 'competent_professional_qualifications', 'competent_professional_relevant_experience', 'competent_professional_email', 'competent_professional_phone', 'competent_professional_exclude_from_rnd_report', 'competent_professional_comments', 'comments', 'escalation_required', 'customer_name', 'customer_contract_details', 'customer_contract_upstream_contract', 'customer_contract_upstream_review', 'field_of_science_and_technology', 'are_rnd_trials_undertaken', 'rate_type', 'run_data_type', 'total_run_duration', 'total_rnd_trial_duration', 'factory_staff_fte', 'waste_ratio', 'total_cost', 'total_qe', 'rnd_percentage', 'total_rnd_hours'];
export const COST_EXPORT_FIELDS_LIST = ['business_unit', 'project_name', 'cost_type_name', 'cost_type_description', 'staffing_cost_employee_role', 'subcontractor_or_epw_connected_party', 'epw_3rd_party_staff_provider', 'materials_item_type', 'total_cost', 'capitalised_costs', 'direct_rnd_%', 'indirect_rnd_%', '%_of_time_spent', 'salary', 'bonus', 'national_insurance', 'reimbursed_expenses', 'pension'];
export const DASHBOARD_TYPES = ['business_unit_intensity_breakdown', 'cost_category_breakdown'];
export const ADMIN_COMMON_ACTIONS = [{
  text: 'add_company_action',
  link: 'companies/new'
}, {
  text: 'add_user_action',
  link: 'users/new'
}, {
  text: 'view_superset_dashboard',
  link: 'dashboards/superset'
}];
export const CONSULTANT_COMMON_ACTIONS = [];
export const CONSULTANT_COMMON_ACTIONS_NO_DASHBOARD = [];
export const SHOW_QUESTIONNAIRES_SELECT_SEPARATELY = true;
export const SHOW_REGULAR_REALTIME_DASHBOARD = true;
export const SHOW_ADD_CLAIM_GROUP_BTN_ON_MASTER_PAGE = true;
export const SHOULD_SHOW_ADD_CLAIM_BUTTON_IN_CLAIM_GROUP_SIDEBAR = true;
export const SHOULD_SHOW_ADD_COMPANY_BUTTON = true;
export const SHOULD_SHOW_ADD_USERS_TO_COMPANY = true;
export const ADD_NEW_USER_TO_COMPANY = true;
export const ACCOUNT_TYPES_THAT_CAN_ADD_USER_TO_COMPANY = ['customer'];
export const SHOULD_SHOW_CREATE_PROJECTS_PAGE_FOR_CUSTOMER = false;
export const SHOW_EDIT_BUTTON_FOR_RESTRICTED_FOLDER = true;
export const FILE_MANAGEMENT_COLUMN_ORDER = ['folderIcon', 'createdAt', 'name', 'notes', 'fileType', 'uploadedBy', 'editButton'];
export const PROJECT_OVERVIEW_ALL_CONTACTS_MAX_AMOUNT_OF_PROJECT_BADGES = 2;
export const SHOW_COMPANY_GROUPS_HEADER = true;
export const SHOW_ADD_PROJECTS_BUTTON_ON_MASTER_PAGE = true;
export const SHOW_IMPORT_PROJECT_AT_PROJECT_OVERVIEW = false;
export const SHOW_ADD_PROJECT_AT_PROJECT_OVERVIEW = true;
export const SHOW_SEND_QUESTIONNAIRE_BUTTON_ON_PROJECT_OVERVIEW_PAGE = true;
export const SHOW_PROJECT_QUESTIONNAIRE_BUTTON_ON_PROJECT_OVERVIEW_PAGE = true;
export const SHOW_QUESTIONNAIRES_TAB_IN_PROJECT_OVERVIEW = false;
export const SHOW_FAQ_ENTRY_HEADER = false;
export const SHOW_CLAIM_GROUPS_SELECTOR = true;
export const UPLOAD_COST_TEMPLATE_PAGE_TITLE = 'Upload Cost Template';
export const UPLOAD_COST_TEMPLATE_BUTTON_NAME = 'Upload Cost Template';
export const DOWNLOAD_COST_TEMPLATE_BUTTON_NAME = 'Download Template';
export const FINANCIAL_DATA_PAGE_NAME = 'Cost Categories';
export const SHOW_CLAIM_DELETE_BUTTON = true;
export const SHOW_ADD_FINANCIAL_YEAR = false;
export const SHOW_BATCH_PROJECT_LOAD_BTN = true;
export const SHOW_ACTION_PERMISSIONS_ON_PROJECT_BUSINESS_UNIT_PARTICIPATION = true;
export const SHOULD_CALL_COMPANY_MENU = false;
export const SHOW_PROJECT_OVERVIEW_COST_SUMMARY_ROW = true;
export const PROJECT_OVERVIEW_HEADER_ELEMENT_STYLES = {
  TOP_ELEMENT: null,
  LOWER_ELEMENT: null
};
export const SHOULD_CREATE_NOT_FOUND_SEARCHED_COMPANY = false;
export const USERS_TYPE_WHO_CAN_INVITE_NEW_USERS = USER_ACCOUNT_TYPES;
export const SHOW_ALERT_POPUP_FOR_DELETE_DOCUMENT_ATTACHMENT_COMPONENT = false;
export const SHOW_CLAIM_GROUP_NAME_ON_MASTER_PAGE = true;
export const SHOW_ADD_PROJECT_LEFT = false;
export const USER_PAGE_CUSTOMER_DISPLAY_FIELDS = {
  admin: ['name', 'role', 'contact', 'is_active'],
  consultant: ['name', 'role', 'is_active'],
  manager: ['name', 'role', 'is_active'],
  super_consultant: [],
  customer: [],
  accountant: []
};
export const COMPANY_BUTTONS_FORM_BOOTSTRAP_CLASS = '';
export const COMPANY_PAGE_PAGINATION_CLASS = 'justify-content-end';
export const UNSAVED_CHANGES_MESSAGE = 'you_have_unsaved_changes_are_you_sure_you_want_to_leave';
export const REVIEW_STATUS = {
  PENDING: 'pending',
  CLARIFICATION_REQUIRED: 'clarification_required',
  CLOSED: 'closed',
  FINALIZED: 'finalized'
};
export const DELETE_FILE_CONFIRMATION_MESSAGE = 'confirm_delete_file_with_name';
export const TECHNICAL_UPLOAD_SUBMIT_BUTTON_TYPE = 'submit';
export const DELETE_BUTTON_TYPE = 'default';
export const ADD_BUTTON_TYPE = 'default';
export const SHOW_NOTIFY_CLAIM_USERS_MODAL = true;
export const ADD_USER_BUTTON_TEXT = 'add_user';
export const ADD_CONTACT_BUTTON_TEXT = 'add_contact';
export const USE_V2_DESIGN = true;